import { computed } from 'vue';

import ImageUtils from '@dh-io-otb/shared/src/services/image.service';

import { useStore } from '@dh-io-otb/shared/src/composables/store.composable';

import { CAR_IMAGE } from '@/models/constants';

import { ModelComposable } from '@/models/entities/model.model';

const useModel = (): ModelComposable => {
  const { state } = useStore();

  const headerImageLg = computed((): string => {
    return ImageUtils.changeImageDefaultFormat(
      state.otbcFlow.model.images?.defaultImage,
      CAR_IMAGE.ROTATION.EXPANDED_HEADER,
      CAR_IMAGE.WIDTH.EXPANDED_HEADER,
    );
  });

  const headerImageSm = computed((): string => {
    return ImageUtils.changeImageDefaultFormat(
      state.otbcFlow.model.images?.defaultImage,
      CAR_IMAGE.ROTATION.COLLAPSED_HEADER,
      CAR_IMAGE.WIDTH.COLLAPSED_HEADER,
    );
  });

  const modelName = computed((): string => {
    return state.otbcFlow.model.name;
  });

  return {
    headerImageSm,
    headerImageLg,
    modelName,
  };
};

export { useModel };
